import { ItfCartCartIconMap } from './type.d';

export const HAS_ECOCART_ICON_MAP: ItfCartCartIconMap[] = [
    {
        path: '/battery-backup-for-home',
        sites: ['us', 'ca'],
    },
    {
        path: '/cost-saving',
        sites: ['us', 'ca', 'za'],
    },
    {
        path: '/delta-3-ultra-series-portable-power-station',
        sites: ['jp'],
    },
    {
        path: '/delta-3-max-series-portable-power-station',
        sites: ['jp'],
    },
    {
        path: '/delta-3-series-portable-power-station',
        sites: ['jp'],
    },
    {
        path: '/glacier-classic-portable-refrigerator',
        sites: ['jp'],
    },
    {
        path: '/glacier-classic-portable-refrigerator/bundles',
        sites: ['jp'],
    },
    {
        path: '/load-shedding-solutions',
        sites: ['za'],
    },
    {
        path: '/living-off-the-grid',
        sites: ['us', 'ca'],
    },
    {
        path: '/recreational-activities',
        sites: ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'nl', 'za', 'au', 'kr'],
    },
    {
        path: '/power-backup',
        sites: ['us', 'ca', 'au', 'kr'],
    },
    {
        path: '/power-independence',
        sites: ['eu', 'uk', 'de', 'fr', 'it', 'es'],
    },
    {
        path: '/river-3-portable-power-station',
        sites: ['jp'],
    },
    {
        path: '/vanlife-roadtrips',
        sites: ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'nl', 'za', 'au', 'kr'],
    },
    {
        path: '/wave-3-portable-air-conditioner',
        sites: ['jp'],
    },
    {
        path: '/wave-3-portable-air-conditioner/bundles',
        sites: ['jp'],
    },
    {
        path: '/power-preparedness',
        sites: ['us', 'ca'],
    },
    {
        path: '/delta-2-max-portable-power-station',
        sites: ['jp'],
    },
];
